// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ExcelLayout from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import {FormattedMessage} from 'react-intl';
import LayoutsPopover from '../../../shared/components/layouts-popover';
import SearchFilters from '../../../shared/state/search-filters';
import TranslatedInput from '../../../shared/components/translated-input';
import TranslatedOption from '../../../shared/components/translated-option';

const sortMap = {
    ASC: 'ascending',
    DESC: 'descending'
};

const handleSortDirectionChange = props => () => {

    const direction = props.searchFilters.sortDirection === 'ASC' ?
        'DESC' :
        'ASC';

    props.onSortDirectionChange(direction, props.type);

};

const handleFilterByChange = props => event => {

    props.onFilterByChange(event.target.value, props.type);

};

const handleSortByChange = props => event => {

    const option = event.target.value.split(',');

    props.onSortByChange(option, props.type);

};

const RefinableListWidget = props => {

    const sortClassName = sortMap[props.searchFilters.sortDirection];

    return (
        <div className='refinable-list'>
            <div className='rounded-bar-filter'>
                <span className='icon-search'/>
                <TranslatedInput
                    onChange={handleFilterByChange(props)}
                    placeholder='FILTER_PLACEHOLDER'
                    type='text'
                    value={props.searchFilters.filterBy}
                />
            </div>
            <div className='rounded-bar-sort'>

                <div className='sort-by-group'>
                    <label>
                        <FormattedMessage id='SORT_BY'/>
                    </label>
                    <select
                        onChange={handleSortByChange(props)}
                        value={props.searchFilters.sortBy.toString()}
                    >
                        {props.sortOptions.map(option =>
                            <TranslatedOption
                                key={option.displayName}
                                text={option.displayName}
                                value={String(option.path)}
                            />
                        )}
                    </select>
                    <button
                        className='button-text'
                        onClick={handleSortDirectionChange(props)}
                        type='button'
                    >
                        <span className={`sort-control ${sortClassName}`}/>
                    </button>
                </div>
            </div>
            {
                props.hasResults &&
                    <LayoutsPopover
                        excelLayouts={props.excelLayouts}
                        onCreateLayout={props.onCreateLayout}
                        onEditLayout={props.onEditLayout}
                        onExport={props.onExport}
                        onLayoutChange={props.onLayoutChange}
                        selectedLayout={props.selectedLayout}
                    />
            }
        </div>
    );

};

RefinableListWidget.displayName = 'RefinableListWidget';
RefinableListWidget.propTypes = {
    excelLayouts: PropTypes.arrayOf(PropTypes.instanceOf(ExcelLayout)).isRequired,
    hasResults: PropTypes.bool,
    onCreateLayout: PropTypes.func.isRequired,
    onEditLayout: PropTypes.func.isRequired,
    onExport: PropTypes.func.isRequired,
    onFilterByChange: PropTypes.func.isRequired,
    onLayoutChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
    onSortDirectionChange: PropTypes.func.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    selectedLayout: PropTypes.instanceOf(ExcelLayout).isRequired,
    sortOptions: PropTypes.array.isRequired,
    type: PropTypes.func
};
RefinableListWidget.defaultProps = {
    hasResults: true
};

export default RefinableListWidget;



// WEBPACK FOOTER //
// ./src/shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts.js